import { createSelector } from 'reselect'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import lessonSelector from 'redux/selectors/lessons/lesson_selector'
import lessonTypes from 'helpers/enums/lessonTypes'

const getMyLibrary = state => state.myLibrary

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.TEACHER_DASHBOARD_SELF_PACED,
	featureFlagsTypes.INTERACTIVE_VIDEO_PREVENT_SKIPPING_VIDEOS,
])

const myLibraryStudentPacedSingleCodeSelector = (sessionUid, presentationUid) => createSelector(
	[getMyLibrary, featureFlagsSelector, lessonSelector],
	(myLibrary, featureFlags, getLesson) => {
		const sessionData = myLibrary.codes.find( code => code.session_uid === sessionUid )
		const lesson = getLesson(presentationUid)

		return {
			sessionData,
			actualTimestamp: myLibrary.actualTimestamp,
			canAccessProgress:
				featureFlags[featureFlagsTypes.TEACHER_DASHBOARD_SELF_PACED] &&
				lesson.data.type !== lessonTypes.VIDEO,
			canAccessStudentSubmissions: lesson.data.type !== lessonTypes.VIDEO ||
				featureFlags[featureFlagsTypes.INTERACTIVE_VIDEO_PREVENT_SKIPPING_VIDEOS],
			shouldShowNewRequiredSubmissionsMessage:
				featureFlags[featureFlagsTypes.INTERACTIVE_VIDEO_PREVENT_SKIPPING_VIDEOS],
		}
	}
)

export default myLibraryStudentPacedSingleCodeSelector
